import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CheckDeposit\DeleteCheckDepositController::deleteMethod
* @see app/Http/Controllers/CheckDeposit/DeleteCheckDepositController.php
* @route '/api/check-deposit/delete/{check_deposit}'
*/
export const deleteMethod = (args: { check_deposit: string | number | { id: string | number } } | [check_deposit: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/check-deposit/delete/{check_deposit}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\CheckDeposit\DeleteCheckDepositController::deleteMethod
* @see app/Http/Controllers/CheckDeposit/DeleteCheckDepositController.php
* @route '/api/check-deposit/delete/{check_deposit}'
*/
deleteMethod.url = (args: { check_deposit: string | number | { id: string | number } } | [check_deposit: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { check_deposit: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { check_deposit: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            check_deposit: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        check_deposit: typeof args.check_deposit === 'object'
        ? args.check_deposit.id
        : args.check_deposit,
    }

    return deleteMethod.definition.url
            .replace('{check_deposit}', parsedArgs.check_deposit.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckDeposit\DeleteCheckDepositController::deleteMethod
* @see app/Http/Controllers/CheckDeposit/DeleteCheckDepositController.php
* @route '/api/check-deposit/delete/{check_deposit}'
*/
deleteMethod.delete = (args: { check_deposit: string | number | { id: string | number } } | [check_deposit: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\CheckDeposit\DeleteCheckDepositController::undo
* @see app/Http/Controllers/CheckDeposit/DeleteCheckDepositController.php
* @route '/api/check-deposit/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/check-deposit/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CheckDeposit\DeleteCheckDepositController::undo
* @see app/Http/Controllers/CheckDeposit/DeleteCheckDepositController.php
* @route '/api/check-deposit/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckDeposit\DeleteCheckDepositController::undo
* @see app/Http/Controllers/CheckDeposit/DeleteCheckDepositController.php
* @route '/api/check-deposit/undo-delete/{id}'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CheckDeposit\DeleteCheckDepositController::undo
* @see app/Http/Controllers/CheckDeposit/DeleteCheckDepositController.php
* @route '/api/check-deposit/undo-delete/{id}'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteCheckDepositController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteCheckDepositController